import { useCallback, useState } from "react";
import submit from "skin/entry/query/submit";

export default function useCode(phone, submitPhone) {
	const [value, setValue] = useState('');
	const [off, setOff] = useState(true);
	const [wait, setWait] = useState(false);
	const [err, setErr] = useState(null);
	const onChange = useCallback(ev => {
		const v = ev.target.value.replace(/[^0-9]/g, '');
		setValue(v);
		setErr(null);
	}, []);
	const request = () => {
		// check(phone).catch(console.error);
		setOff(true);
	}
	const send = () => {
		setWait(true);
		submit(phone, value)
		.then(submitPhone)
		.catch(err => {
			console.error('err', err);
			setErr(err.toString());
		})
		.finally(() => setWait(false))
	};
	const onComplete = useCallback(() => {
		setOff(false);
	}, []);
	return { value, onChange, off, request, onComplete, send, wait, err };
}